/**
 * Russian UI strings. Mirror of en.js — same keys.
 *
 * Plural strategy: phrases are reformulated so the form is plural-invariant
 * (e.g. "Импортировано: 5" instead of "Imported 5 project(s)"). No plural helper.
 *
 * Per PLAN.md, hint about viewBox stays in English even in RU mode — it's a
 * technical CSS term and the field is for power users who paste raw SVG.
 */

export default {
  // ── toolbar ─────────────────────────────────────────────────────
  'toolbar.import_json':        '↑ Импорт JSON',
  'toolbar.export_json':        '↓ Экспорт JSON',
  'toolbar.reset':              '↺ Сбросить к демо',
  'toolbar.export_html':        'Экспорт HTML для печати →',
  'toolbar.untitled':           'Без имени',

  // ── save indicator ──────────────────────────────────────────────
  'project.indicator.loaded':              'Загружено',
  'project.indicator.no_storage':          'Нет хранилища',
  'project.indicator.saving':              'Сохранение…',
  'project.indicator.saved':               'Сохранено',
  'project.indicator.save_failed':         'Ошибка сохранения (квота?)',
  'project.indicator.storage_unavailable': 'Хранилище недоступно',

  // ── sidebar ─────────────────────────────────────────────────────
  'sidebar.structure':       'Структура',
  'sidebar.editor':          'Редактор',
  'sidebar.preview':         'Превью',
  'sidebar.add_section':     '+ Добавить раздел',
  'sidebar.untitled_poster': 'Постер без названия',
  'sidebar.footer_label':    'Подвал · Раскрытие · Контакты',
  'sidebar.empty_section':   '(пусто)',
  'sidebar.move_up':         'Вверх',
  'sidebar.move_down':       'Вниз',
  'sidebar.delete':          'Удалить',
  'sidebar.duplicate':       'Дублировать',
  'sidebar.header_icon':     'Ш',
  'sidebar.footer_icon':     'П',

  // ── preview overlay ────────────────────────────────────────────
  'preview.size_label': 'A0 · 841 × 1189 мм',
  'preview.zoom_in':    'Увеличить',
  'preview.zoom_out':   'Уменьшить',
  'preview.zoom_fit':   'Подогнать',
  'preview.overflow_banner': '⚠ Контент выходит за рамку A0 на {n} мм — сократи текст или ужми графики перед печатью',

  // ── editor empty states ────────────────────────────────────────
  'editor.empty.select_or_add': 'Выбери раздел слева или добавь новый.',
  'editor.empty.no_renderer':   'Нет редактора для типа «{type}».',
  'editor.empty.select_item':   'Выбери элемент слева.',

  // ── editor section headers ─────────────────────────────────────
  'editor.section.header.label':           'Шапка',
  'editor.section.header.badge':           'заголовок · авторы · логотипы',
  'editor.section.header.meta':            'Верхний блок постера',

  'editor.section.footer.label':           'Подвал',
  'editor.section.footer.badge':           'раскрытие · этика · контакты',
  'editor.section.footer.meta':            'Нижняя строка постера',

  'editor.section.intro_row.label':        'Вступительный ряд',
  'editor.section.intro_row.meta':         'Раздел №{n} · две колонки рядом',

  'editor.section.case_grid.label':        'Сетка карточек',
  'editor.section.case_grid.meta':         'Раздел №{n} · карточки на половину/всю ширину',

  'editor.section.chart_with_aside.label': 'График + блок решения',
  'editor.section.chart_with_aside.meta':  'Раздел №{n} · большой график + панель решения',

  'editor.section.charts_row.label':       'Ряд графиков',
  'editor.section.charts_row.meta':        'Раздел №{n} · несколько SVG-графиков в ряд',

  'editor.section.findings_block.label':   'Выводы + Take-home',
  'editor.section.findings_block.meta':    'Раздел №{n} · ключевые выводы + ограничения + take-home',

  // ── section type catalog ───────────────────────────────────────
  'section_type.intro_row.label':        'Вступительный ряд',
  'section_type.intro_row.desc':         'Две колонки (широкая + узкая)',
  'section_type.case_grid.label':        'Сетка карточек',
  'section_type.case_grid.desc':         'Карточки на половину/всю ширину',
  'section_type.chart_with_aside.label': 'График + блок решения',
  'section_type.chart_with_aside.desc':  'Большой SVG + боковая панель',
  'section_type.charts_row.label':       'Ряд графиков',
  'section_type.charts_row.desc':        'Несколько SVG-графиков в ряд',
  'section_type.findings_block.label':   'Выводы + Take-home',
  'section_type.findings_block.desc':    'Выводы + ограничения + take-home',

  // ── editor subgroups ───────────────────────────────────────────
  'editor.subgroup.authors':            'Авторы',
  'editor.subgroup.logos':              'Логотипы (справа в шапке)',
  'editor.subgroup.affiliations':       'Аффилиации',
  'editor.subgroup.disclosures_col':    'Колонка «Раскрытие»',
  'editor.subgroup.ethics_col':         'Колонка «Этика»',
  'editor.subgroup.contact_col':        'Колонка «Контакты»',
  'editor.subgroup.column_n':           'Колонка {n}',
  'editor.subgroup.cards':              'Карточки',
  'editor.subgroup.chart_left':         'График (слева, ~70%)',
  'editor.subgroup.aside_right':        'Боковой блок решения (справа, ~30%)',
  'editor.subgroup.charts':             'Графики',
  'editor.subgroup.findings_left':      'Выводы (слева)',
  'editor.subgroup.limitations_middle': 'Ограничения (центр, красный)',
  'editor.subgroup.takehome_right':     'Take-home (справа, navy)',

  // ── editor subcards ────────────────────────────────────────────
  'editor.subcard.author_n':   'Автор №{n}',
  'editor.subcard.logo_n':     'Логотип №{n}',
  'editor.subcard.card_n':     'Карточка №{n}',
  'editor.subcard.chart_n':    'График №{n}',
  'editor.subcard.subgroup_n': 'Подгруппа №{n}',
  'editor.subcard.finding_n':  'Вывод №{n}',
  'editor.subcard.item_n':     '#{n}',

  // ── editor field labels ────────────────────────────────────────
  'editor.field.poster_title':     'Заголовок постера',
  'editor.field.subtitle':         'Подзаголовок / примечание',
  'editor.field.name':             'Имя',
  'editor.field.role':             'Роль',
  'editor.field.affiliation_num':  'Номер аффилиации',
  'editor.field.image_src':        'Источник (путь или data URI)',
  'editor.field.image_embedded':   'Встроенное изображение · {kb} КБ · ↑ для замены, ✕ для удаления',
  'editor.field.alt':              'Alt-текст',
  'editor.field.heading':          'Заголовок',
  'editor.field.disclosure_text':  'Текст раскрытия',
  'editor.field.ethics_text':      'Текст об этике',
  'editor.field.contact_label':    'Подпись (например, «Корреспондирующий автор»)',
  'editor.field.email':            'Email',
  'editor.field.note':             'Примечание',
  'editor.field.qr_url':           'URL для контакта (QR создаётся автоматически)',
  'editor.field.qr_svg':           'SVG QR-кода',
  'editor.field.width':            'Ширина',
  'editor.field.title':            'Заголовок',
  'editor.field.section_title':    'Заголовок раздела',
  'editor.field.paragraphs':       'Абзацы (можно HTML)',
  'editor.field.body_html':        'Текст (можно HTML)',
  'editor.field.body':             'Текст',
  'editor.field.chart_title':      'Заголовок графика',
  'editor.field.svg_full':         'SVG-разметка (вставь полный <svg>…</svg>)',
  'editor.field.svg':              'SVG-разметка',
  'editor.field.vega_spec':        'Vega-Lite спецификация (JSON)',

  // ── chart editor (один основной путь + Advanced) ────────────────
  'editor.chart.type_label':       'Тип:',
  'editor.chart.add_row':          'Добавить строку',
  'editor.chart.no_rows':          'Данных нет — нажми «+ Добавить строку»',
  'editor.chart.type_switch_confirm': 'Смена типа графика заменит текущие данные на пример нового пресета. Продолжить?',
  'editor.chart.advanced':         'Расширенно',
  'editor.chart.enter_spec':       'Редактировать Vega-Lite spec напрямую',
  'editor.chart.enter_spec_desc':  'Полный контроль над спецификацией — таблица данных перестаёт использоваться.',
  'editor.chart.enter_svg':        'Вставить готовый SVG',
  'editor.chart.enter_svg_desc':   'Используй график из R / Prism / Excel / Illustrator.',
  'editor.chart.spec_banner':      'Кастомная Vega-Lite спека — таблица данных не используется.',
  'editor.chart.svg_banner':       'Используется вставленный SVG — конструктор графика отключён.',
  'editor.chart.back_to_builder':  '← Вернуться к конструктору',
  'editor.chart.exit_mode_confirm': 'Отбросить этот контент и вернуться к конструктору?',

  // ── chart presets ────────────────────────────────────────────────
  'preset.annotated_timeline.label': 'Размеченный таймлайн',
  'preset.annotated_timeline.desc':  'Линейный график значения по времени с необязательными подписями событий в точках.',
  'preset.line_by_group.label':      'Линия по группам',
  'preset.line_by_group.desc':       'Линейный график с несколькими сериями — по одной линии на группу.',
  'preset.bar_error.label':          'Столбцы с error bars',
  'preset.bar_error.desc':           'Столбчатый график категорий с error bars (среднее ± SD).',
  'preset.boxplot.label':            'Boxplot',
  'preset.boxplot.desc':             'Распределение значений по категориальным группам.',
  'preset.scatter_regression.label': 'Скаттер с регрессией',
  'preset.scatter_regression.desc':  'Точечный график с наложенной линией линейной регрессии.',
  'preset.forest_plot.label':        'Forest plot',
  'preset.forest_plot.desc':         'Размер эффекта с 95% ДИ по исследованиям, нулевая референс-линия.',

  'editor.chart.label_tooltip':  'Кликни, чтобы переименовать — становится подписью оси',

  'toast.not_image':             'Файл не является изображением',
  'editor.field.caption':          'Подпись',
  'editor.field.icon_char':        'Символ-иконка',
  'editor.field.subgroup_title':   'Заголовок подгруппы',
  'editor.field.items':            'Пункты',
  'editor.field.outcome':          'Итог (зелёный блок снизу)',
  'editor.field.references':       'Ссылки',
  'editor.field.limitation_items': 'Пункты ограничений',
  'editor.field.takehome_items':   'Пункты take-home',

  // ── color themes ───────────────────────────────────────────────
  'toolbar.theme_label':       'Тема:',
  'theme.navy_red.label':      'Синий + красный',
  'theme.teal_orange.label':   'Бирюзовый + оранжевый',
  'theme.monochrome.label':    'Монохром',
  'theme.warm_rust.label':     'Тёплый бордо',
  'theme.custom.label':        'Произвольная',
  'theme.edit_colors':         'Изменить цвета',
  'theme.popover_title':       'Произвольная палитра',
  'theme.reset_palette':       'Сбросить палитру',
  'theme.var.navy':            'Шапка и тёмные блоки',
  'theme.var.navy_dark':       'Заголовки',
  'theme.var.navy_light':      'Фон карточек',
  'theme.var.accent_red':      'Акцент (цифры, маркеры)',
  'theme.var.accent_soft':     'Фон акцентных боксов',

  // ── editor field hints ─────────────────────────────────────────
  'editor.hint.subtitle': 'Курсивная строка под авторами (необязательно)',
  'editor.hint.aff_eg':   'например, 1',
  'editor.hint.qr_gen':    'Сгенерируй, например, на qr-code-generator.com',
  'editor.hint.qr_auto':   'Вставь URL — SVG QR ниже обновится',
  'editor.hint.qr_manual': 'Заполняется из URL выше или вставь сырой SVG',
  'editor.hint.viewbox':  'viewBox controls scaling',
  'editor.hint.icon_eg':  'например, ! или ◆',

  // ── select options ─────────────────────────────────────────────
  'editor.option.width.wide':   'Широкая (~58%)',
  'editor.option.width.narrow': 'Узкая (~42%)',
  'editor.option.width.half':   'Половина (1/2)',
  'editor.option.width.full':   'На всю ширину',

  // ── add buttons ────────────────────────────────────────────────
  'editor.action.add_author':         '+ Добавить автора',
  'editor.action.add_logo':           '+ Добавить логотип',
  'editor.action.upload_logo':        'Загрузить изображение',
  'editor.action.drop_logo_hint':     'Перетащи изображение сюда или нажми ↑ для загрузки',
  'editor.action.add_affiliation':    'Добавить аффилиацию',
  'editor.action.add_reference':      'Добавить ссылку',
  'editor.action.add_paragraph':      'Добавить абзац',
  'editor.action.add_card':           '+ Добавить карточку',
  'editor.action.add_aside_subgroup': '+ Добавить подгруппу',
  'editor.action.add_item':           'Добавить пункт',
  'editor.action.add_chart':          '+ Добавить график',
  'editor.action.add_finding':        '+ Добавить вывод',
  'editor.action.add_limitation':     'Добавить ограничение',
  'editor.action.add_takehome':       'Добавить take-home',

  // ── project menu ───────────────────────────────────────────────
  'project.menu.list_title':    'Проекты ({n})',
  'project.menu.empty':         'Проектов пока нет',
  'project.menu.storage_warn':  '⚠ Хранилище недоступно — проекты не сохранятся',
  'project.menu.new':           '＋ Новый проект',
  'project.menu.rename':        '✎ Переименовать текущий',
  'project.menu.export_bundle': '↓ Экспорт всех проектов (бэкап)',
  'project.menu.import_bundle': '↑ Импорт бандла',
  'project.imported_fallback':  'Импортированный',

  // ── confirm / prompt ───────────────────────────────────────────
  'confirm.delete_section': 'Удалить этот раздел?',
  'confirm.delete_project': 'Удалить проект «{name}»? Это нельзя отменить.',
  'confirm.reset':          'Сбросить к демо-постеру? Несохранённые изменения в этом проекте будут потеряны.',
  'prompt.rename_project':  'Переименовать проект:',

  // ── toasts ─────────────────────────────────────────────────────
  'toast.added_section':     'Добавлено: {label}',
  'toast.storage_warn':      'localStorage недоступен — изменения не сохранятся между сессиями',
  'toast.save_failed':       'Ошибка сохранения — возможно, localStorage переполнен. Сделай экспорт-бэкап.',
  'toast.new_project':       'Создан новый проект',
  'toast.renamed':           'Переименовано',
  'toast.deleted':           'Удалено',
  'toast.bundle_exported':   'Экспортировано: {n}',
  'toast.bundle_invalid':    'Файл бандла некорректен',
  'toast.bundle_imported':   'Импортировано: {n}',
  'toast.import_failed':     'Ошибка импорта: {msg}',
  'toast.html_saved':        'HTML для печати сохранён — открой в Chrome, печать в PDF (A0)',
  'toast.json_saved':        'JSON-конфиг сохранён',
  'toast.json_imported':     'JSON-конфиг импортирован',
  'toast.json_invalid_keys': 'JSON должен содержать ключи header, sections и footer',
  'toast.reset_done':        'Сброшено к демо',

  // ── relative time ──────────────────────────────────────────────
  'time.just_saved': 'Сохранено',
  'time.s_ago':      '{n} с назад',
  'time.m_ago':      '{n} мин назад',
  'time.h_ago':      '{n} ч назад',

  // ── section template starters ──────────────────────────────────
  'tpl.section_title':       'Заголовок раздела',
  'tpl.lead_paragraph':      'Вводный абзац здесь.',
  'tpl.side_panel':          'Боковая панель',
  'tpl.short_complementary': 'Короткий дополняющий текст.',
  'tpl.card_a':              'Карточка A',
  'tpl.card_a_body':         'Текст карточки A.',
  'tpl.card_b':              'Карточка B',
  'tpl.card_b_body':         'Текст карточки B.',
  'tpl.figure_title':        'Заголовок рисунка',
  'tpl.figure_caption':      'Подпись/интерпретация рисунка.',
  'tpl.aside_title':         'Заголовок блока',
  'tpl.subgroup_a':          'Подгруппа A',
  'tpl.point_one':           'Пункт первый',
  'tpl.point_two':           'Пункт второй',
  'tpl.outcome_statement':   '✓ Формулировка итога',
  'tpl.figure_a':            'Рисунок A',
  'tpl.figure_b':            'Рисунок B',
  'tpl.caption_a':           'Подпись A',
  'tpl.caption_b':           'Подпись B',
  'tpl.key_findings':        'Ключевые выводы',
  'tpl.finding_one_title':   'Вывод первый.',
  'tpl.finding_one_body':    'Текст вывода первого.',
  'tpl.finding_two_title':   'Вывод второй.',
  'tpl.finding_two_body':    'Текст вывода второго.',
  'tpl.limitations_title':   '⚠ Ограничения',
  'tpl.limitation_one':      'Ограничение первое.',
  'tpl.limitation_two':      'Ограничение второе.',
  'tpl.takehome_title':      '◆ Take-home',
  'tpl.takehome_one':        'Take-home первый.',
  'tpl.takehome_two':        'Take-home второй.',

  'tpl.new_author':   'Новый автор',
  'tpl.new_card':     'Новая карточка',
  'tpl.new_chart':    'Новый график',
  'tpl.new_subgroup': 'Новая подгруппа',
  'tpl.new_finding':  'Новый вывод.',

  'tpl.svg_paste':       'Вставь сюда SVG',
  'tpl.svg_placeholder': 'SVG-плейсхолдер',
  'tpl.svg_paste_short': 'Вставь SVG',
};
